import { selectChangeMessageForImage } from '@UI/aside/asideImage/asideImageSelectors';
import type { EditAsideImage, ImageOptionField } from '@nodeTypeConfig/configTypes';

export const imageComponentBase = {
  reactComponent: 'AsideImage',
  component: 'image',
  property: 'attachments',
  label: 'Afbeelding',
  asideChangeMessageSelector: selectChangeMessageForImage,
} as const;

export const imageAlt: ImageOptionField[] = ['alt'];

export const imageComponent: EditAsideImage = {
  ...imageComponentBase,
  options: {
    type: 'ILLUSTRATION',
    fields: [],
  },
};
